var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 214,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.495 0h216.01v214H.494z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.495,
    cy: 106,
    r: 67.711,
    transform: "rotate(-45 110.495 106)",
    fill: "#CCD6F4",
    fillOpacity: 0.2,
    stroke: "#DEE5F9",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.495,
    y: 61.342,
    width: 6.203,
    height: 50.862,
    rx: 3.101,
    fill: "#9BABD9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.495,
    y: 82,
    width: 8,
    height: 30,
    rx: 4,
    fill: "#6B7BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.303 110.015h4.019a2.015 2.015 0 0 0 2.009-2.01 2.015 2.015 0 0 0-2.009-2.009h-4.019v4.019zM57.832 110.015h4.018v-4.019h-4.018c-1.105 0-2.01.904-2.01 2.009 0 1.106.904 2.01 2.01 2.01zM113.021 58.079V54.06c0-1.105-.904-2.01-2.01-2.01a2.015 2.015 0 0 0-2.009 2.01v4.019h4.019zM113.021 160.546v-4.019h-4.019v4.019c0 1.105.904 2.01 2.009 2.01 1.106 0 2.01-.905 2.01-2.01zM43.193 204.574a6.88 6.88 0 0 1-6.889-6.889.758.758 0 0 0-.765-.765.758.758 0 0 0-.765.765 6.88 6.88 0 0 1-6.89 6.889.758.758 0 0 0-.765.766c0 .428.337.765.766.765a6.88 6.88 0 0 1 6.889 6.889c0 .429.336.766.765.766a.758.758 0 0 0 .765-.766 6.88 6.88 0 0 1 6.89-6.889.758.758 0 0 0 .765-.765.758.758 0 0 0-.766-.766z",
    fill: "#9BABD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.059 14.95a13.437 13.437 0 0 1-13.455-13.455A1.48 1.48 0 0 0 160.109 0a1.48 1.48 0 0 0-1.495 1.495c0 7.445-6.01 13.455-13.455 13.455a1.48 1.48 0 0 0-1.495 1.495 1.48 1.48 0 0 0 1.495 1.495c7.445 0 13.455 6.01 13.455 13.455a1.48 1.48 0 0 0 1.495 1.495 1.48 1.48 0 0 0 1.495-1.495c0-7.445 6.01-13.455 13.455-13.455a1.48 1.48 0 0 0 1.495-1.495 1.48 1.48 0 0 0-1.495-1.495zM26.113 172.712a10.75 10.75 0 0 1-10.764-10.764c0-.67-.526-1.196-1.196-1.196-.67 0-1.196.526-1.196 1.196a10.75 10.75 0 0 1-10.764 10.764c-.67 0-1.196.526-1.196 1.196 0 .67.526 1.196 1.196 1.196a10.75 10.75 0 0 1 10.764 10.764c0 .67.526 1.196 1.196 1.196.67 0 1.196-.526 1.196-1.196a10.75 10.75 0 0 1 10.764-10.764c.67 0 1.196-.526 1.196-1.196 0-.67-.526-1.196-1.196-1.196z",
    fill: "#DEE5F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.495)",
    d: "M0 0h216.009v214H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ba47aeebd0ef6f9edb96969108cc5459.svg";
export { ForwardRef as ReactComponent };